export default __webpack_public_path__ + "static/media/world.fc22a0c0.svg";